
export const AccordionSelect = {
  props: {
    list: Array
  },
  data() {
    return {
      currentItem: null
    }
  },
  mounted() {
    if (this.list && this.list.length > 0) {
      this.currentItem = this.list[0]
    }
  },
  computed: {
    selectedLabel() {
      return this.currentItem && this.currentItem.label ? this.currentItem.label : ''
    },
    accordionId() {
      return 'accordion-' + Math.floor(Math.random() * 9999999999)
    }
  },
  template: `
  <div class="accordion accordion-select" :id="accordionId"> 
    <div class="card mb-2"> 
      <div class="card-header p-0" :id="'heading-' + accordionId"> 
          <h2 class="mb-0"> 
              <button class="btn btn-block text-left btn--primary color--gray-700 border--2" type="button" data-toggle="collapse" :data-target="'#collapse-' + accordionId" aria-expanded="false" :aria-controls="'#collapse-' + accordionId"> 
                  {{selectedLabel}}
              </button> 
          </h2> 
      </div>
      <div :id="'collapse-' + accordionId" class="collapse" :aria-labelledby="'heading-' + accordionId" :data-parent="'#' + accordionId" style=""> 
        <div class="card-body px-5 px-lg-6 py-lg-5"> 
          <ul class="accordion-select__item">
            <sidebar-menu-item v-for="item in list"
              :item="item"
              :key="item.id"></sidebar-menu-item>
          </ul>
        </div> 
      </div> 
    </div> 
  </div>  
  `
}
